var DefaultHeader = require("common/DefaultHeader");
var PopupMenu = require("common/PopupMenu");
var Utils = require("common/Utils");

Utils.inherits(TOTPHeader, DefaultHeader);

/**
 * Header implementation used for Main TOTP page
 *
 * @class
 * @extends DefaultHeader
 */
function TOTPHeader() {
    DefaultHeader.call(this);

    var optionsMenu = new PopupMenu("optionsMenuContainer");
    $("#mobileResources").append(optionsMenu.getContent());

    var super_configure = this.configure;
    /**
     * Configure the header with a menu button on the left and the necessary CSS class for the resources header
     *
     * @override
     */
    this.configure = function(config) {
        var optionsButton = optionsMenu.getButton();

        if (config.leftButtons) {
            config.leftButtons.push(optionsButton);
        } else {
            config.leftButtons = [optionsButton];
        }

        super_configure.call(this, config);
    };

    this.addOptionsMenuEntry = function(title, clickHandler, weight) {
        return optionsMenu.addEntry(title, clickHandler, weight);
    };
}

Utils.inherits(TOTPHeader, DefaultHeader);

module.exports = TOTPHeader;